import { RequestDefinition } from 'front-end-core/core/Api'

import {
  toCryptoKeyList,
  toUser,
  toUsers,
  toUserAuth,
  toSearchHistory,
  toTracking
} from './transforms'

import {
  URL_CRYPTO_KEY_LIST,
  URL_USER,
  URL_USERS,
  URL_USER_AUTH,
  URL_SEARCH_HISTORY,
  URL_TRACKING
} from 'constants/urls'

import {
  CRYPTO_KEY_LIST,
  USER,
  USERS,
  USER_AUTH,
  SEARCH_HISTORY,
  TRACKING
} from 'constants/requests'

export const CryptoKeyList = new RequestDefinition({
  name: CRYPTO_KEY_LIST,
  url: URL_CRYPTO_KEY_LIST,
  transform: toCryptoKeyList
})

export const User = new RequestDefinition({
  name: USER,
  url: URL_USER,
  transform: toUser
})

export const Users = new RequestDefinition({
  name: USERS,
  url: URL_USERS,
  transform: toUsers
})

export const UserAuth = new RequestDefinition({
  name: USER_AUTH,
  url: URL_USER_AUTH,
  transform: toUserAuth
})

export const SearchHistory = new RequestDefinition({
  name: SEARCH_HISTORY,
  url: URL_SEARCH_HISTORY,
  transform: toSearchHistory
})

export const Tracking = new RequestDefinition({
  name: TRACKING,
  url: URL_TRACKING,
  transform: toTracking
})
